import { Colors, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const colors = {
  ...LightThemeColors,
  cardBackgroundColorThree: Colors.white,
  loaderContentColor: Colors.lightGrayTwo,
  yearColor: Colors.blackTwoRGBA(0.5),
};

export default colors;
